import {useRoute} from "vue-router";
import {withBack} from "@/utils/returnLink.js";

// Content links add ?back=<this page> so a Back card on the next page can find its way back.
// Navigation (menus, footer) and external links do not use it.
export function useBackLinks() {
    const route = useRoute();
    return (href) => withBack(href, route?.path);
}
